import * as React from 'react'
import { TimerWrapper, TimerProgress } from './styles'

interface TimerProps {
  recordingProgress: number
  playbackProgress: number
  inPlayback: boolean
}

export const Timer: React.FC<TimerProps> = ({
  inPlayback,
  recordingProgress,
  playbackProgress,
}) => (
  <TimerWrapper>
    <TimerProgress inPlayback={false} progress={recordingProgress} />
    {inPlayback ? (
      <TimerProgress inPlayback={inPlayback} progress={playbackProgress} />
    ) : null}
  </TimerWrapper>
)
